// 活动管理 - 成绩管理
import service from '@/utils/request'

// 成绩列表
export function getActRanking (data) {
  return service({
    url: '/service/admin/getActRanking',
    method: 'post',
    params: data
  })
}

// 导入成绩
// export function actEnrollImport (data) {
//   return service({
//     url: '/service/admin/actEnrollImport',
//     method: 'post',
//     params: data,
//   })
// }

// 下载模板
export function downloadActUserTemp (data) {
  return service({
    url: '/service/admin/actEnrollExport',
    method: 'post',
    params: data,
    responseType: 'blob'
  })
}

// 修改成绩
export function setActRanking (data) {
  return service({
    url: '/service/admin/setActRanking',
    method: 'post',
    params: data,
  })
}
